import React from 'react';
import PropTypes from 'prop-types';

import VideoIllustration from '@component/illustration/video-illustration';
import I18n from '@app/modules/i18n/index';
import Router from '@module/router';
import { userHasPlusTier } from '@app/helper/user';

const EmailVerificationSuccess = ({ create, user }) => {
  function handleSendFilesClick() {
    create();

    // When Pro users verify their account email start the on-boarding process,
    // if and only if they haven't been on-boarded yet.
    if (!user.preferences.onboarded && userHasPlusTier(user)) {
      Router.navigateTo('/payment/completed');
    }
  }

  return (
    <div className="transfer__window email-verification-success">
      <div className="transfer__contents email-verification-success__contents">
        <VideoIllustration
          type="transfer-complete-upload"
          src="transfer_window/transfer_completed-1"
          className="email-verification-success__image"
        />
        <h2 className="email-verification-success__title">
          {I18n.t('transfer.email-verification-success.title')}
        </h2>
        <p className="email-verification-success__text">
          {I18n.t('transfer.email-verification-success.body')}
        </p>
      </div>
      <div className="transfer__footer email-verification-success__footer">
        <button className="transfer__button" onClick={handleSendFilesClick}>
          {I18n.t('transfer.email-verification-success.send_files')}
        </button>
      </div>
    </div>
  );
};

EmailVerificationSuccess.propTypes = {
  create: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};

export default EmailVerificationSuccess;
